module.exports = __webpack_public_path__ + "data/history.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/history/history.json
// module id = 8HS2
// module chunks = 1